import { render, staticRenderFns } from "./TabsChart.vue?vue&type=template&id=dd958152&scoped=true"
import script from "./TabsChart.vue?vue&type=script&lang=js"
export * from "./TabsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd958152",
  null
  
)

export default component.exports